import React from 'react'
import classnames from 'classnames/bind'

import { Title } from 'components/typo'
import Image from 'components/shared/Image'
import RichText from 'components/typo/RichText'

import css from './styles.module.scss'

const cx = classnames.bind(css)

const IconTitleText = ({
  icon,
  title,
  text,
  iconLayout,
  animated,
  index,
  className,
}) => {
  return (
    <div className={cx(css.IconTitleText, className, iconLayout)}>
      <div className={css.container}>
        {icon && (
          <div className={css.iconContainer}>
            <div className={css.iconWrapper}>
              <Image className={css.icon} {...icon} />
            </div>
          </div>
        )}
        {title && (
          <div>
            <Title size="small" className={css.title}>
              {title}
            </Title>
          </div>
        )}
      </div>
      {text && (
        <div className={css.textWrapper}>
          <RichText
            text={text}
            type="Text"
            size="medium"
            markdownProps={{
              disallowedTypes: ['paragraph'],
              unwrapDisallowed: true,
            }}
          />
        </div>
      )}
    </div>
  )
}

IconTitleText.defaultProps = {
  animated: true,
  stagger: 0,
}

export default IconTitleText
